/** Société tier labels for Status Match program → tier mappings (payload: targetSocieteTier). */
export const SOCIETE_MATCH_TARGET_TIERS = ['Silver', 'Gold', 'Platinum'] as const;

/** Société tier slugs for Status Claim payloads (payload: tiers[]). */
export const SOCIETE_CLAIM_TIERS = ['silver', 'gold', 'platinum'] as const;

export const SOCIETE_CLAIM_TIER_LABELS: Record<(typeof SOCIETE_CLAIM_TIERS)[number], string> = {
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
};

export const TARGET_TIER_TOKEN = '{targetTier}';

export const DEFAULT_CHALLENGE_CARD_TITLE_SUFFIX = ' Status Match Offer';
export const DEFAULT_CHALLENGE_CARD_SUBTITLE_BEFORE = 'Complete the steps below to unlock ';
export const DEFAULT_CHALLENGE_CARD_SUBTITLE_AFTER = ' status';

export const PREVIEW_REQUIRED = '[required]';

export const CONDITION_ICON_OPTIONS = [
  { value: 'clock', label: 'Clock' },
  { value: 'calendar', label: 'Calendar' },
  { value: 'star', label: 'Star' },
  { value: 'lock', label: 'Lock' },
  { value: 'shield', label: 'Shield' },
  { value: 'check', label: 'Check' },
] as const;

export const CLAIM_CAMPAIGNS_URL = '/societe/claim-campaigns';

export const DEFAULT_STATUS_CLAIM_TERMS_SLUG = 'societe-terms-and-conditions';
export const DEFAULT_SECONDARY_SECTION_TITLE = 'Discover the Benefits of Société';
export const DEFAULT_STATUS_CLAIM_SECONDARY_SUBTITLE =
  "Explore what's included with each status tier. Your final tier will be confirmed after validation.";
export const DEFAULT_STATUS_CLAIM_HERO_IMAGE_ID = 'tier-upgrade-hero-image-206d895f0ff3';
export const DEFAULT_STATUS_CLAIM_HERO_TITLE = 'Enjoy Complimentary Société Status';

export const DEFAULT_STATUS_MATCH_HERO_TITLE = 'Bring your status.';
export const DEFAULT_STATUS_MATCH_HERO_SUBTITLE = "We'll match it.";
export const DEFAULT_STATUS_MATCH_HERO_DESCRIPTION =
  "Hold elite status with another program? Share your status details, book an eligible escape and we'll match you to an equivalent Société tier. Limited time only.";
export const DEFAULT_STATUS_MATCH_HERO_CTA_TEXT = 'Apply for Status Match';
export const DEFAULT_STATUS_MATCH_HERO_IMAGE_ID = 'match-campaign-hero-image-1';
export const DEFAULT_STATUS_MATCH_VERIFICATION_IMAGE_ID = 'status-match-verification-image-test';

export const SUCCESS_STEP_DEFINITIONS = [
  {
    key: 'qualifying_stay',
    title: 'Book and complete your stay',
    description: 'At least 3 nights within 3 months',
  },
  {
    key: 'review_complete',
    title: 'We review within 4 weeks',
    description: 'Once verified, your tier will be upgraded',
  },
] as const;
